import { useContext, useEffect } from 'react';
import { ApiErrorContext } from './ApiProvider';
import dynamicConfig from '../config/dynamicConfig';
import ErrorPage from '../components/ErrorPage';

const ApiErrorOrRender = ({ children }) => {
    const { apiError, wafError } = useContext(ApiErrorContext);

    // Log WAF errors in the backend
    useEffect(() => {
        const { wafErrorId, url: rawUrl } = wafError;
        if (!wafErrorId || !rawUrl) {
            return;
        }

        const url = btoa(encodeURIComponent(rawUrl));

        // Send to log. We don't care about the answer.
        fetch(`${dynamicConfig.atmUrl}/log-frontend-error/waf?waf-error-id=${wafErrorId}&url=${url}`)
            .catch(() => null);
    }, [wafError.wafErrorId, wafError.url]);

    if (apiError) {
        return <ErrorPage errorKey="sbkApiCommunicationError" />;
    }

    if (wafError.wafErrorId) {
        return <ErrorPage errorKey="sbkApiWafError" />;
    }

    return children;
};

export default ApiErrorOrRender;
